import store from 'app/store';
import { EncoderJob, Actions } from './types';
import getJobParam from './helpers/get-job-param';

export const getJobsByParam = param => {
  const state = store.getState();

  return state.jobs.filter(job => {
    return job.params.filter(p => p.key === param.key && p.value === param.value).length > 0;
  });
};

export const getJobForEpisode = episodeId => {
  return getJobsByParam({ key: 'episodeId', value: episodeId }).first() || null;
};

export const getJobForMediaUrl = url => {
  return getJobsByParam({ key: 'mediaUrl', value: url }).first() || null;
};

export const createNewJob = data => {
  const job = EncoderJob.create(data);
  store.dispatch({
    type: Actions.CREATE,
    data: job,
  });
  return job;
};

export const updateJobWithParam = (param, data) => {
  store.dispatch({
    type: Actions.UPDATE,
    data: { param, data },
  });
  return getJobsByParam(param).first() || null;
};

export const updateJob = (job, data) => {
  return updateJobWithParam({ key: 'mediaUrl', value: getJobParam(job, 'mediaUrl') }, data);
};

export const removeJob = job => {
  store.dispatch({
    type: Actions.REMOVE,
    data: { key: 'mediaUrl', value: getJobParam(job, 'mediaUrl') },
  });
};
